<template>
  <div
    class="fixed min-h-screen w-full flex justify-center items-center"
    style="background: rgba(0, 0, 0, 0.3); z-index: 100"
  >
    <div>
      <img :src="loading" alt="loading" />
    </div>
  </div>
</template>

<script setup>
// eslint-disable-next-line no-unused-vars
import loading from "@/assets/img/loading.gif";
</script>
